// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true
    },
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<p class="sold-out-badge">' + bcSfFilterConfig.label.sold_out + '</p>',
    'saleLabelHtml': '<div class="sale-badge">' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div class="indiv-product-vendor-text"><a href="{{itemVendorUrl}}">{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div class="grid__item ' + bcSfFilterConfig.custom.grid_item_width + '  indiv-product-wrapper {{itemCycleClass}}">' +
                                '<div class="indiv-product">' +
                                    '{{itemImage}}' +
                                    '<div class="hp-title">' +
                                        '{{itemVendor}}' +
                                        '<a href="{{itemUrl}}">' +
                                            '<div class="indiv-product-title-text">{{itemTitle}}</div>' +
                                            '<span class="money-styling custom-font">{{itemPrice}}</span>' +
                                        '</a>' +
                                    '</div>' +
                                '</div>' +
                                '{{itemLabels}}' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="pagination-arrow pagination-arrow--previous grid__item col-sm-4 col-md-4 col-xs-4"><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><i class="fa fa-chevron-left"></i> <span class="icon__fallback-text">Previous</span></a></li>',
    'previousDisabledHtml': '<li class="pagination-arrow pagination-arrow--previous grid__item col-sm-4 col-md-4 col-xs-4"><div class="btn btn--secondary btn--narrow btn--disabled"><i class="fa fa-chevron-left"></i> <span class="icon__fallback-text">Previous</span></div></li>',
    'nextActiveHtml': '<li class="pagination-arrow pagination-arrow--next grid__item col-sm-4 col-md-4 col-xs-4"><a href="{{itemUrl}}" class="btn btn--secondary btn--narrow"><span class="icon__fallback-text">Next</span> <i class="fa fa-chevron-right"></i></a></li>',
    'nextDisabledHtml': '<li class="pagination-arrow pagination-arrow--next grid__item col-sm-4 col-md-4 col-xs-4"><div class="btn btn--secondary btn--narrow btn--disabled"><span class="icon__fallback-text">Next</span> <i class="fa fa-chevron-right"></i></div></li>',
    'paginateHtml': '<ul>{{previous}}<li class="pagination-text grid__item col-sm-4 col-md-4 col-xs-4"><div class="hidden-xs">{{pageItems}}</div></li>{{next}}</ul>',

    // Sorting Template
    'sortingHtml': '<label for="bc-sf-filter-top-sorting-select">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add cycle class
    var itemCycleClass = '';
    switch (bcSfFilterConfig.custom.products_per_row) {
        case 2:
            if (index == 1 || (index > 2 && index % 2 == 1)) itemCycleClass = ' alpha mobile-clear tablet-clear';
            else itemCycleClass = ' omega';
            break;
        case 3:
            if (index == 1 || (index > 6 && index % 6 == 1)) itemCycleClass = ' alpha mobile-clear';
            else if (index == 2 || (index > 6 && index % 6 == 2)) itemCycleClass = '';
            else if (index == 3 || (index > 6 && index % 6 == 3)) itemCycleClass = ' mobile-clear omega';
            else if (index == 4 || (index > 6 && index % 6 == 4)) itemCycleClass = ' alpha';
            else if (index == 5 || (index > 6 && index % 6 == 5)) itemCycleClass = ' mobile-clear';
            else itemCycleClass = ' omega';
            break;
        case 4:
            if (index == 1 || (index > 4 && index % 4 == 1)) itemCycleClass = ' alpha mobile-clear tablet-clear';
            else if (index == 2 || (index > 4 && index % 4 == 2)) itemCycleClass = '';
            else if (index == 3 || (index > 4 && index % 4 == 3)) itemCycleClass = ' mobile-clear tablet-clear';
            else itemCycleClass = ' omega';
            break;
    }
    itemHtml = itemHtml.replace(/{{itemCycleClass}}/g, itemCycleClass);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '760x') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Image / Flip Image
    var itemImageHtml = ''
    switch(bcSfFilterConfig.custom.hover_effect) {
        case 'none':
            itemImageHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}">';
            itemImageHtml += '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
            itemImageHtml += '</a>';
            break;
        case 'second-image':
            if (images.length > 1) {
                itemImageHtml += '<div class="reveal">';
                itemImageHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}">';
                itemImageHtml += '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
                itemImageHtml += '<div class="hidden">';
                itemImageHtml += '<img src="' + this.optimizeImage(images[1]['src'], '760x') + '" alt="{{itemTitle}}" class="img-responsive" />';
                itemImageHtml += '</div>';
                itemImageHtml += '</a></div>';
            } else {
                itemImageHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}">';
                itemImageHtml += '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
                itemImageHtml += '</a>';
            }
            break;
        case 'zoom':
            itemImageHtml += '<div class="collection-image--zoom-effect"><div class="zoom-effect--inner">';
            itemImageHtml += '<a href="{{itemUrl}}" title="{{itemTitle}}">';
            itemImageHtml += '<img src="' + itemThumbUrl + '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
            itemImageHtml += '</a>';
            itemImageHtml += '</div></div>';
            break;
    }
    itemHtml = itemHtml.replace(/{{itemImage}}/g, itemImageHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.show_vendor ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor).replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor)) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
        itemPriceHtml += '<span class="money pty_money">'+ bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) +'</span>';
        itemPriceHtml += '<small class="custom-font compare-at-price">';
        itemPriceHtml += '<span class="money">' + this.formatMoney(data.compare_at_price_max) + '</span>';
        itemPriceHtml += '</small>';
    }
    if(!onSale){
      if (priceVaries) {
        itemPriceHtml += '<small>' + bcSfFilterConfig.label.from_price + '</small> <span class="money">' + this.formatMoney(data.price_min) + '</span>';
      }else{
        itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
      }
    }
    
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Label
    var itemLabelsHtml = '';
    if (!soldOut) {
        itemLabelsHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    } else {
        itemLabelsHtml = bcSfFilterTemplate.soldOutLabelHtml;
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, 'Page ' + currentPage + ' of ' + totalPage);

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
    $("#bc-sf-filter-top-sorting select").selectOrDie({
        customClass: "custom",
        customID:    "custom"
    });

    var _this = this;
    jQ('.sod_option').click(function(e) {
        onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('value'));
    })
};

// Show Filter Tree on Mobile
BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
    var _this = this;
    jQ(this.selector.filterTreeMobileButton).unbind('click');
    jQ(this.selector.filterTreeMobileButton).on('click', function() {
        jQ('#collection-sidebar').slideToggle();
        // Re-initialize jscrollpane
        _this.buildFilterScrollbar();
    });
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
